/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-footer[_ngcontent-%COMP%]{flex:0 0 auto;display:flex;flex-wrap:wrap;justify-content:center;align-items:center;font-size:.68em;padding-bottom:10px;padding-top:10px}a[_ngcontent-%COMP%]{padding-left:5px;padding-right:5px}"];
export { styles as styles };
